import { gql } from '@apollo/client';

export const getOrgUnitMembers = gql`
  query($page: Int!, $perPage: Int!, $filter: GqlPractitionersFilter!) {
    user {
      dashboard {
        practitionerPagination(
          page: $page
          perPage: $perPage
          filter: $filter
        ) {
          pageInfo {
            totalItems
            page
            perPage
            totalPages
            hasNextPage
            hasPreviousPage
          }
          items {
            id
            firstName
            description
            lastName
            description
            email
            photoUrl
            gender
            phone
            birthDate
            preferredLanguages
            address {
              country
              city
              address
              zipcode
            }
            professionalNumber
            specialities
            subOrganizations {
              id
              name
              location {
                id
                name
                address {
                  country
                  city
                  address
                  zipcode
                }
                preferredTimeZone
              }
            }
            careTeams {
              id
              name
            }
            roleIds
            roles
            sendbirdId
            workingHours {
              dayOfWeek
              morningOpeningTime
              morningClosingTime
              afternoonOpeningTime
              afternoonClosingTime
            }
            #appointmentDuration
          }
        }
      }
    }
  }
`;
